import Swiper from 'swiper';

// jQuery(($) => {
//   $('section.related').removeClass('relatedProductSlider swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-free-mode swiper-container-android');
//   $('section.related ul.products').removeClass('swiper-wrapper');
//   $('section.related ul.products li.product').removeClass('swiper-slide swiper-slide-active');
//   $('section.upsells').removeClass('upsellsProductSlider swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-free-mode swiper-container-android');
//   $('section.upsells ul.products').removeClass('swiper-wrapper');
//   $('section.upsells ul.products li.product').removeClass('swiper-slide swiper-slide-active');
//   $('section.cross-sells').removeClass('crossellsProductSlider swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-free-mode swiper-container-android');
//   $('section.cross-sells ul.products').removeClass('swiper-wrapper');
//   $('section.cross-sells ul.products li.product').removeClass('swiper-slide swiper-slide-active');
// });
//
// jQuery(($) => {
//   $('section.related').removeClass('relatedProductSlider swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-free-mode swiper-container-android');
//   $('section.related ul.products').removeClass('swiper-wrapper');
//   $('section.related ul.products li.product').removeClass('swiper-slide swiper-slide-active');
//   $('section.upsells').removeClass('upsellsProductSlider swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-free-mode swiper-container-android');
//   $('section.upsells ul.products').removeClass('swiper-wrapper');
//   $('section.upsells ul.products li.product').removeClass('swiper-slide swiper-slide-active');
//   $('section.cross-sells').removeClass('crossellsProductSlider swiper-container swiper-container-initialized swiper-container-horizontal swiper-container-free-mode swiper-container-android');
//   $('section.cross-sells ul.products').removeClass('swiper-wrapper');
//   $('section.cross-sells ul.products li.product').removeClass('swiper-slide swiper-slide-active');
// });

const relatedProducts = new Swiper('.relatedProductSlider', {
  speed: 400,
  freeMode: true,
  slidesPerView: 'auto',
  spaceBetween: 8,
  breakpoints: {
    318: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
  },
});

const upsellsProducts = new Swiper('.upsellsProductSlider', {
  speed: 400,
  freeMode: true,
  slidesPerView: 'auto',
  spaceBetween: 8,
  breakpoints: {
    318: {
      slidesPerView: 1.5,
      spaceBetween: 0,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
  },
});

const crosssellsProducts = new Swiper('.crossellsProductSlider', {
  speed: 400,
  freeMode: true,
  slidesPerView: 'auto',
  spaceBetween: 8,
  breakpoints: {
    318: {
      slidesPerView: 1.5,
      spaceBetween: 0,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
  },
});

const crossSellsProducts = new Swiper('.crossSellsProductSlider', {
  speed: 400,
  freeMode: true,
  slidesPerView: 'auto',
  spaceBetween: 8,
  breakpoints: {
    318: {
      slidesPerView: 1.5,
      spaceBetween: 0,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
  },
});

const accessoriesProductSlider = new Swiper('.accessoriesProductSlider', {
  speed: 400,
  freeMode: true,
  slidesPerView: 'auto',
  spaceBetween: 8,
  breakpoints: {
    318: {
      slidesPerView: 1.5,
      spaceBetween: 0,
    },
    480: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
  },
});
